import React from 'react';

import { Box, Button, HStack, Heading, Text } from '@betterment/samba-react';
import { BettermentLogo, TakeoverHeader } from '@betterment/style-closet-react';

import { mockAgreementsData, mockSimpleAdvisoryFee } from './mocks';

import AdvisoryAgreements from '../../Agreements/AdvisoryAgreements';
import PricingPlan from '../../Agreements/PricingPlan';
import TermsAndConditions from '../../Agreements/TermsAndConditions';
import { AdvisorFee, ClientAgreements } from '../../FirmTermsAcceptance/data';
import Pencils from '../../images/pencils.png';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';

const AgreementsApp: React.FC = () => {
  // TODO: Replace with GraphQL query
  const data: {
    inviteId: string;
    firmLogoUrl: string | undefined;
    firmName: string;
    advisorFee: AdvisorFee;
    platformFee: string;
    agreements: ClientAgreements;
  } = {
    inviteId: 'mock-invite-123',
    firmLogoUrl: undefined,
    firmName: mockAgreementsData.firmName,
    advisorFee: mockSimpleAdvisoryFee,
    platformFee: mockAgreementsData.platformFee,
    agreements: mockAgreementsData.agreements,
  };

  const { firmLogoUrl, firmName, advisorFee, platformFee, agreements } = data;
  const redirectToHome = () => {
    locationAssign(urlBuilder.appHome.absolute());
  };

  return (
    <HStack
      css={{
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: '100vh',
      }}
    >
      <Box
        css={{
          display: { base: 'none', lg: 'block' },
          height: '100vh',
          overflow: 'hidden',
          '& img': {
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            display: 'block',
          },
        }}
      >
        <img src={Pencils} alt="Pencils on notebook" />
      </Box>
      <Box
        css={{
          width: { base: '100%', lg: '55%' },
          height: '100vh',
          overflowY: 'auto',
          pb: 'space.800',
          px: { base: 'space.300', lg: 'space.600' },
        }}
      >
        <Box css={{ position: 'relative' }}>
          <TakeoverHeader
            title="New client agreements"
            closeHandler={redirectToHome}
            logo={firmLogoUrl ? <img src={firmLogoUrl} alt="Firm logo" /> : <BettermentLogo />}
          />
        </Box>
        <Box>
          <Heading
            as="h1"
            css={{
              mt: 'space.400',
              mb: 'space.200',
              fontSize: 'fontSize.600',
              fontWeight: 'fontWeights.bold',
            }}
          >
            Make {firmName} your advisor
          </Heading>
          <Box
            css={{
              width: { base: '90%', lg: '70%' },
            }}
          >
            <Text
              as="p"
              css={{
                marginBottom: 'space.300',
              }}
            >
              Below is some important information regarding {firmName}&apos;s financial services. Your advisory
              agreement with {firmName} is an agreement solely between you and your advisor, and Betterment and its
              affiliates are not by any means acquiring any obligation or legal duties by permitting it to be executed
              here. Declining to make {firmName} your advisor will have no impact to your existing Betterment account.
            </Text>

            <PricingPlan advisorFee={advisorFee} firmName={firmName} platformFee={platformFee} />

            <TermsAndConditions />

            <AdvisoryAgreements firmName={firmName} agreements={agreements} />

            <Text
              as="p"
              css={{
                marginBottom: 'space.400',
              }}
            >
              By clicking confirm, I acknowledge that I have read and agree to the terms above.
            </Text>
          </Box>
        </Box>
        <Button type="submit">Confirm</Button>
      </Box>
    </HStack>
  );
};

export default AgreementsApp;
